export { stringLength } from "#string-length";
